export default __webpack_public_path__ + "static/media/ITR-22.fbfa3343.png";